export interface FolderNode {
  name: string;
  path: string;
  children: FolderNode[];
}

/**
 * Build a sorted, deduplicated folder tree from a list of folder paths
 * (forward-slash separated, no leading/trailing slashes). Empty input or
 * empty strings produce a root node with no children.
 */
export function buildFolderTree(paths: string[]): FolderNode {
  const root: FolderNode = { name: '', path: '', children: [] };
  for (const raw of paths) {
    if (!raw) continue;
    const parts = raw.split('/');
    let cursor = root;
    let acc = '';
    for (const part of parts) {
      acc = acc ? `${acc}/${part}` : part;
      let next = cursor.children.find((c) => c.name === part);
      if (!next) {
        next = { name: part, path: acc, children: [] };
        cursor.children.push(next);
      }
      cursor = next;
    }
  }
  const sort = (node: FolderNode): FolderNode => {
    node.children.sort((a, b) => a.name.localeCompare(b.name));
    node.children.forEach(sort);
    return node;
  };
  return sort(root);
}
